export default function reverseChronological(date1, date2){
	return new Date(date2) - new Date(date1)
}




// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/util/dateComparison.js